export const GoogleMapApiConfig = 'AIzaSyB0CzVuzya4xQAczzE0hxyZEl40X1cp_ZE';